import * as redux from 'redux';
import thunk from 'redux-thunk';

export default (combineReducers, initialState = {}) => {
  const store = redux.createStore(combineReducers, initialState, redux.compose(
    redux.applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  ));

  return store;
};
